import { SvgIcon, SvgIconProps } from '@mui/material';

const TackleBoxFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="TackleBoxFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.75 3C16.4403 3.00001 17 3.55965 17 4.25V6H21.2715C21.8774 6.00001 22.3899 6.4331 22.5 7.01758L22.5166 7.13672L22.9941 12.3896L22.999 12.4883L22.9961 12.5859L22.5137 19.833C22.4699 20.4896 21.9237 21 21.2656 21H16.1543C15.6809 20.9999 15.2478 20.732 15.0361 20.3086L14.3818 19H9.61816L8.96386 20.3086C8.75216 20.732 8.31908 20.9999 7.8457 21H2.73437C2.11732 21 1.59925 20.5513 1.50097 19.9541L1.48632 19.833L1.0039 12.5859C0.999557 12.5206 0.999927 12.4549 1.00585 12.3896L1.48339 7.13672L1.5 7.01758C1.61005 6.43309 2.12254 6 2.72851 6H7V4.25C7 3.55964 7.55964 3 8.25 3H15.75ZM10.25 11C9.84148 11 9.48005 11.1969 9.25195 11.5H3V13.5H9V13.75C9 14.4404 9.55964 15 10.25 15H13.75C14.4403 15 15 14.4404 15 13.75V13.5H21V11.5H14.748C14.5199 11.1969 14.1585 11 13.75 11H10.25ZM9 6H15V5H9V6Z"
      />
    </SvgIcon>
  );
};

export default TackleBoxFilled;
